import React from 'react'
import { motion } from 'framer-motion'
import {Skill} from '../components'
import skills from '../constants'

export default function Skills() {
  return (
    <motion.div 
    initial={{opacity:0}}
    whileInView={{opacity:1}}
    transition={{duration:1.5}}
    className='h-screen flex relative flex-col text-center md:text-left xl:flex-row max-w-[2000px] xl:px-10 min-h-screen justify-center xl:space-y-0 mx-auto items-center'>
        <h3 className='absolute top-24 uppercase tracking-[20px] text-gray-500 text-2xl'>
            Skills
        </h3>

        <h3 className='absolute top-36 uppercase tracking-[3px] text-gray-500 text-sm'>
            Hover over a skill for currency proficiency
        </h3>

        <div className='grid grid-cols-4 md:grid-cols-5 md:gap-5 md:pt-10 gap-3'>
            {skills.map((item) => (
              <Skill skill={item.skill} percent={item.percent}/>
            ))}
        </div>
    </motion.div>
  )
}